<div>
  <app-toolbar [isAuth]="isAuth"></app-toolbar>
</div>
<div style="height: 100%; overflow: auto;">
  <app-sidenav [isAuth]="isAuth"></app-sidenav>
</div>
<!-- <main>
  <router-outlet></router-outlet>
</main> -->